import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AssessmentTemplate, Question } from './DataDefinitions';

interface QuestionarieTemplate {
    role: string;
    questions: Question[];
}

const Template = ({
    data, title,
}: { data: AssessmentTemplate, title?: string }) => {
    const { t } = useTranslation();

    const assessment: QuestionarieTemplate = JSON.parse(data.assessment);
    const questions: Question[] = assessment.questions;

    return (
        <Card>
            <Card.Header className="pt-3 pb-2">
                <h3>{title}</h3>
            </Card.Header>
            <Card.Body className="pb-0">

                <Accordion defaultActiveKey="0">
                    {questions.map((question, index) => (
                        <Accordion.Item key={index} eventKey={index + ""} className="border-top border-300">
                            <Accordion.Header>{question.competence} - {t("QuestionarieRO.evaluation")} {question.evaluation}</Accordion.Header>
                            <Accordion.Body className="pt-0">
                                {question.description}
                                <br />
                                <strong>{t("QuestionarieRO.target_level")} {question.expected_level}</strong>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Card.Body>
            <Card.Footer className="border-top-0">

            </Card.Footer>
        </Card>
    );
};

export default Template;
